export default __webpack_public_path__ + "static/media/Blood Choker.fa3ad8cb.jpg";